module.exports = __webpack_public_path__ + "img/header1.d5346966.jpg";